// @flow

/**
 * Answer Toggle Context
 * Provides the summary/detail toggle state to the <answer-summary> and
 * <answer-detail> components rendered within a single agent message.
 */

import { createContext, useContext } from 'react';

export type AnswerToggleContextValue = {
  showDetail: boolean,
  setShowDetail: (show: boolean) => void,
  isMessageStreaming: boolean,
  exportMode: boolean,
};

export const AnswerToggleContext = createContext<?AnswerToggleContextValue>(null);

/**
 * Hook to access the summary/detail toggle state.
 * Returns null when used outside a chat message (graceful degradation).
 */
export function useAnswerToggle(): ?AnswerToggleContextValue {
  return useContext(AnswerToggleContext);
}
